import React from 'react';
import { Button, Card, Typography, Space, Alert, Row, Col } from 'antd';
import { ExclamationCircleOutlined, ArrowLeftOutlined, DatabaseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const MockDataWarningPage: React.FC = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/admin/mock-data/management');
  };

  const handleGoBack = () => {
    navigate('/admin/dashboard');
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto', minHeight: 'calc(100vh - 200px)', display: 'flex', alignItems: 'center' }}>
      <Row gutter={[16, 16]} justify="center" style={{ width: '100%' }}>
        <Col xs={24} sm={20} md={18} lg={16}>
          <Card 
            style={{ 
              textAlign: 'center',
              border: '2px solid #ff4d4f',
              boxShadow: '0 4px 12px rgba(255, 77, 79, 0.15)'
            }}
          >
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <ExclamationCircleOutlined 
                style={{ 
                  fontSize: '72px', 
                  color: '#ff4d4f' 
                }} 
              />
              
              <Title level={2} style={{ color: '#ff4d4f', margin: 0 }}>
                ⚠️ DANGER ZONE ⚠️
              </Title>
              
              <Alert
                message="Warning: Mock Data Operations"
                description="You are about to enter the Mock Data management section. This area contains powerful tools that can modify or delete data in your system."
                type="error"
                showIcon
                style={{ textAlign: 'left' }}
              />
              
              <div style={{ textAlign: 'left' }}>
                <Title level={4}>
                  <DatabaseOutlined /> What is Mock Data?
                </Title>
                <Paragraph>
                  Mock data consists of artificial organizations, brands, surveys, and responses created for:
                  <ul>
                    <li><strong>Testing purposes</strong> - Validate system functionality</li>
                    <li><strong>Development</strong> - Provide sample data for development</li>
                    <li><strong>Demonstrations</strong> - Show system capabilities to stakeholders</li>
                  </ul>
                </Paragraph>
                
                <Title level={4} style={{ color: '#ff4d4f' }}>
                  ⚠️ Important Warnings:
                </Title>
                <Alert
                  message="Critical Information"
                  description={
                    <ul style={{ margin: 0, paddingLeft: '16px' }}>
                      <li><strong>Mock data operations are IRREVERSIBLE</strong></li>
                      <li><strong>Cleaning mock data will permanently delete all mock organizations and related data</strong></li>
                      <li><strong>Generating mock data will create artificial data that may affect analytics</strong></li>
                      <li><strong>Only proceed if you understand the implications</strong></li>
                      <li><strong>This should only be used in development/staging environments</strong></li>
                    </ul>
                  }
                  type="error"
                  showIcon
                  style={{ textAlign: 'left', marginTop: '16px' }}
                />
              </div>
              
              <div style={{ marginTop: '32px' }}>
                <Space size="large">
                  <Button
                    type="default"
                    size="large"
                    icon={<ArrowLeftOutlined />}
                    onClick={handleGoBack}
                  >
                    Go Back to Dashboard
                  </Button>
                  
                  <Button
                    type="primary"
                    danger
                    size="large"
                    icon={<DatabaseOutlined />}
                    onClick={handleContinue}
                    style={{ whiteSpace: 'normal', height: 'auto', minHeight: '40px', padding: '8px 16px' }}
                  >
                    I Understand - Continue
                  </Button>
                </Space>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MockDataWarningPage;